<template>
  <div>
    <v-dialog v-model="loginShow" id="loginForm" persistent max-width="450" overlay-opacity=".5">
      <v-card class="pb-1" v-if="!loginAsPerson">
        <v-card-title class="headline align-start justify-space-between">
          <span class="text-uppercase">{{ $t("card.login") }}</span>
          <v-btn icon @click="closeLogin">
            <v-icon>{{ iconClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" v-html="$t('text.welcome-login')"> </v-col>
            <v-col cols="12">
              <v-alert v-if="loginError === 401 && !processing" dense type="error" :icon="iconAlert"
                class="modal-alert v-alert--narrow v-alert--bubble bottom--left mb-3">
                {{ $t("error.login-fail-desc") }}
              </v-alert>
              <v-alert v-if="loginError === 403 && !processing" dense type="error" :icon="iconAlert"
                class="modal-alert v-alert--narrow v-alert--bubble bottom--left mb-3">
                {{ $t("error.account-is-not-valid") }}
              </v-alert>
              <v-alert v-if="
                !processing &&
                loginError &&
                loginError !== 403 &&
                loginError !== 401
              " dense type="error" :icon="iconAlert"
                class="modal-alert v-alert--narrow v-alert--bubble bottom--left mb-3">
                {{ $t("error." + loginError) }}
              </v-alert>

              <v-text-field v-model="form.username" :error-messages="usernameErrors" :counter="10" label="Username"
                required v-on:input="$v.form.username.$touch()" v-on:blur="$v.form.username.$touch()"
                v-on:keyup.enter="submit"></v-text-field>
              <v-text-field v-model="form.password" :error-messages="passwordErrors" :counter="20" label="Password"
                required v-bind:type="passType" v-on:input="$v.form.password.$touch()"
                v-on:blur="$v.form.password.$touch()" v-on:keyup.enter="submit">
                <v-tooltip slot="append" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="primary" v-on="on" v-bind="attrs" v-on:click="togglePass">
                      <v-icon v-if="passType === 'password'">{{
                        iconEye
                        }}</v-icon>
                      <v-icon v-else>{{ iconEyeClose }}</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="passType === 'password'">{{
                    $t("tooltip.show-pass")
                    }}</span>
                  <span v-else>{{ $t("tooltip.hide-pass") }}</span>
                </v-tooltip>
              </v-text-field>
              <span class="change-pass-link" @click="changePasswordLink">
                Klik Di sini untuk mengganti Password
              </span>
              <span style="font-size: 0.76rem;color:red;display:block;text-decoration:none">Lakukan pergantian password
                berkala
                (setiap 6 bulan)</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-5 py-3">
          <v-btn color="primary" medium outlined :loading="processing" :disabled="processing"
            v-on:click="submit"><v-icon class="mr-2">{{ iconLogin }}</v-icon>
            {{ $t("button.login") }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="pb-1" v-if="loginAsPerson">
        <v-card-title class="headline align-start justify-space-between">
          <span class="text-uppercase">{{ $t("card.login") }}</span>
          <v-btn icon @click="closeLogin">
            <v-icon>{{ iconClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card outlined tile color="primary" height="100" max-height="150" class="mb-4 card__select-person rounded"
            @click="loginAs(loginAsPerson[0].key)">
            <v-card-title class="headline white--text">
              <span style="font-size: 1rem">
                {{ $t("text.login-as-fixed-position") }}
              </span>
            </v-card-title>
            <v-card-subtitle class="white--text">
              <span style="font-size: 1.2rem">
                {{ loginAsPerson[0].name }}
              </span>
              <v-icon class="login__as-button">{{ iconClick }}</v-icon>
            </v-card-subtitle>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog 1: Persetujuan Pemberitahuan Privasi (EULA) -->
    <!-- persistent: klik di luar tidak menutup dialog; Esc ditangkap lewat keydown = menolak -->
    <v-dialog :value="eulaShow" persistent max-width="450" overlay-opacity=".5" @keydown.esc="disagreeEula">
      <v-card class="eula-card">
        <div class="d-flex justify-end pt-2 pr-2">
          <v-btn icon small aria-label="Tutup" :disabled="processing" @click="disagreeEula">
            <v-icon>{{ iconClose }}</v-icon>
          </v-btn>
        </div>
        <v-card-text class="text-center pb-2">
          <div class="eula-card__icon mx-auto mb-4">
            <v-icon color="white">{{ iconShield }}</v-icon>
          </div>
          <div class="eula-card__title mb-3">Persetujuan Penggunaan Aplikasi</div>
          <div class="eula-card__desc mb-4">
            Dalam rangka penerapan Undang-Undang Pelindungan Data Pribadi (PDP) dan ISO/IEC 27701:2025, kami meminta
            persetujuan Anda atas Pemberitahuan Privasi aplikasi ELEMEN.
            Pemberitahuan ini menjelaskan tujuan, jenis, dan cara pemrosesan data pribadi Anda. Mohon dibaca terlebih
            dahulu sebelum memberikan persetujuan.
          </div>
          <v-btn color="#c2410c" dark depressed rounded class="text-none" @click="privacyShow = true">
            <v-icon small class="mr-2">{{ privacyHasRead ? iconCheckCircle : iconOpenNew }}</v-icon>
            Baca Pemberitahuan Privasi
          </v-btn>
          <v-divider class="my-4"></v-divider>
          <div v-if="!privacyHasRead" id="eula-read-hint" class="eula-card__hint text-left mb-2">
            Baca Pemberitahuan Privasi sampai selesai untuk mengaktifkan persetujuan.
          </div>
          <!--
            aria-describedby diteruskan Vuetify ke elemen input checkbox.
            Label lewat prop (bukan v-slot:label): di Vue 2.7 slot tanpa scope hilang dari $slots
            setelah parent re-render, sehingga label VCheckbox menjadi kosong.
          -->
          <v-checkbox v-model="eulaChecked" :disabled="!privacyHasRead" hide-details
            :aria-describedby="privacyHasRead ? undefined : 'eula-read-hint'"
            label="Saya telah membaca, memahami, dan menyetujui Pemberitahuan Privasi (Privacy Notice) aplikasi."
            class="mt-0 pt-0 text-left eula-card__check" :class="{ 'eula-card__check--locked': !privacyHasRead }">
          </v-checkbox>
        </v-card-text>
        <v-card-actions class="px-6 pb-2">
          <v-row dense>
            <v-col cols="6">
              <v-btn block depressed rounded dark color="#e3001b" class="text-none" :disabled="processing"
                @click="disagreeEula">
                Tidak Setuju
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn block depressed rounded color="primary" class="text-none"
                :disabled="!privacyHasRead || !eulaChecked || processing" :loading="processing" @click="agreeEula">
                Setuju &amp; Lanjutkan
                <v-icon small class="ml-2">{{ iconArrowRight }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <div class="text-center grey--text text--darken-1 pb-4 pt-2 eula-card__footer">
          PT Perkebunan Nusantara IV (PalmCo)
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog 2: Isi Pemberitahuan Privasi (Privacy Notice) -->
    <!--
      Sengaja di-bind satu arah (:value, tanpa v-model/@input) dan persistent, tanpa tombol X:
      Esc dan klik di luar tidak menutup dialog. Satu-satunya jalan keluar adalah tombol
      "Saya Sudah Membaca" yang baru muncul setelah syarat baca terpenuhi.
    -->
    <v-dialog :value="privacyShow" persistent scrollable max-width="760" overlay-opacity=".5">
      <v-card class="privacy-card">
        <v-card-title>
          <span class="privacy-card__title">Pemberitahuan Privasi (Privacy Notice)</span>
        </v-card-title>
        <v-divider></v-divider>
        <!-- div biasa (bukan v-card-text) agar ref & event scroll bisa dipakai; tabindex untuk scroll keyboard -->
        <div ref="privacyContent" class="v-card__text privacy-card__body overflow-y-auto" tabindex="0"
          aria-label="Isi Pemberitahuan Privasi" @scroll.passive="measurePrivacyScroll">
          <privacy-notice-content />
        </div>
        <v-divider></v-divider>
        <v-progress-linear :value="privacyHasRead ? 100 : privacyScrollPct" height="4"
          :color="privacyHasRead ? 'success' : 'amber darken-2'"></v-progress-linear>
        <v-card-actions class="flex-wrap px-6 py-3">
          <div class="privacy-card__status mr-auto" aria-live="polite">{{ privacyStatusText }}</div>
          <v-btn v-if="privacyHasRead" color="primary" depressed class="text-none" @click="privacyShow = false">
            <v-icon small class="mr-2">{{ iconCheckCircle }}</v-icon>
            Saya Sudah Membaca
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  mdiAccount,
  mdiAccountClock,
  mdiAlertCircleOutline,
  mdiArrowRight,
  mdiCheckCircle,
  mdiClose,
  mdiCursorDefaultClick,
  mdiEye,
  mdiEyeOff,
  mdiLogin,
  mdiOpenInNew,
  mdiShieldCheckOutline,
} from "@mdi/js";
import { validationMixin } from "vuelidate";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";
import { sendDeviceLocation } from "@/constants/config.js";
import PrivacyNoticeContent from "@/components/commonComponents/PrivacyNoticeContent.vue";

// Waktu baca minimum (detik) selama dialog Pemberitahuan Privasi terbuka & tab aktif
const MIN_READ_SECONDS = 30;
// Toleransi (px) dasar konten agar sub-pixel / zoom browser tetap dihitung sampai akhir
const SCROLL_END_TOLERANCE = 8;

export default {
  mixins: [validationMixin],
  name: "login",
  components: { PrivacyNoticeContent },
  data: () => ({
    iconClose: mdiClose,
    iconLogin: mdiLogin,
    iconUser: mdiAccount,
    iconUserStar: mdiAccountClock,
    iconClick: mdiCursorDefaultClick,
    iconAlert: mdiAlertCircleOutline,
    iconEye: mdiEye,
    iconEyeClose: mdiEyeOff,
    iconShield: mdiShieldCheckOutline,
    iconOpenNew: mdiOpenInNew,
    iconArrowRight: mdiArrowRight,
    iconCheckCircle: mdiCheckCircle,
    eulaShow: false,
    eulaChecked: false,
    eulaClientInfo: undefined,
    privacyShow: false,
    // posisi scroll terjauh (%), tidak turun walau digulir kembali ke atas
    privacyScrollPct: 0,
    privacySecondsLeft: MIN_READ_SECONDS,
    passType: "password",
    form: {
      username: undefined,
      password: undefined,
    },
    myDeviceDetail: undefined,
  }),
  validations: {
    form: {
      username: { required, maxLength: maxLength(10), minLength: minLength(7) },
      password: { required, maxLength: maxLength(20), minLength: minLength(8) },
    },
  },
  props: {
    loginShow: { type: Boolean },
  },
  computed: {
    ...mapState("user", [
      "loginAsPerson",
      "loginError",
      "processing",
      "currentUser",
    ]),
    // syarat baca: digulir sampai akhir DAN waktu baca minimum habis
    privacyHasRead() {
      return this.privacyScrollPct >= 100 && this.privacySecondsLeft <= 0;
    },
    privacyStatusText() {
      if (this.privacyHasRead)
        return "Selesai dibaca. Anda dapat menutup dan menyetujui.";

      const parts = [];
      if (this.privacyScrollPct < 100)
        parts.push(`Gulir sampai akhir dokumen (${this.privacyScrollPct}%)`);
      if (this.privacySecondsLeft > 0)
        parts.push(`waktu baca minimum ${this.privacySecondsLeft} detik`);
      return parts.join(" · ");
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.form.username.$dirty) return errors;
      !this.$v.form.username.maxLength &&
        errors.push(
          `${this.$t("text.username-max-length-is")} 10 ${this.$t(
            "text.characters"
          )}`
        );
      !this.$v.form.username.minLength &&
        errors.push(
          `${this.$t("text.username-min-length-is")} 7 ${this.$t(
            "text.characters"
          )}`
        );
      !this.$v.form.username.required &&
        errors.push(`${this.$t("text.username-is-required")}`);
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;
      !this.$v.form.password.maxLength &&
        errors.push(
          `${this.$t("text.password-max-length-is")} 20 ${this.$t(
            "text.characters"
          )}`
        );
      !this.$v.form.password.minLength &&
        errors.push(
          `${this.$t("text.password-min-length-is")} 5 ${this.$t(
            "text.characters"
          )}`
        );
      !this.$v.form.password.required &&
        errors.push(`${this.$t("text.password-is-required")}`);
      return errors;
    },
  },
  watch: {
    eulaShow(show) {
      // setiap dialog persetujuan dibuka ulang, progres baca dimulai dari awal
      if (show) this.resetPrivacyProgress();
      else this.privacyShow = false;
    },
    privacyShow(show) {
      // timer hanya berjalan selama isi Pemberitahuan Privasi terbuka; sisa waktu dilanjutkan saat dibuka lagi
      if (!show) return this.stopPrivacyTimer();

      // konten pendek (layar besar) tidak memicu event scroll, jadi ukur sekali setelah terbuka
      this.$nextTick(() => this.measurePrivacyScroll());

      if (this.privacyTimer || this.privacySecondsLeft <= 0) return;
      this.privacyTimer = setInterval(() => {
        // jeda saat tab tidak aktif
        if (document.hidden) return;
        this.privacySecondsLeft -= 1;
        if (this.privacySecondsLeft <= 0) this.stopPrivacyTimer();
      }, 1000);
    },
  },
  created() {
    // handle interval sengaja tidak reaktif (bukan di data)
    this.privacyTimer = undefined;
    this.setProcessing(false);
  },
  beforeDestroy() {
    this.stopPrivacyTimer();
  },
  methods: {
    ...mapActions("user", [
      "login",
      "signOut",
      "setProcessing",
      "loginAsCancel",
      "setLoginAsPerson",
    ]),
    changePasswordLink() {
      // Implementation for changing password link
      window.location.replace("https://ion.palmco.id/auth/forgot-password");
    },
    togglePass() {
      this.passType = this.passType === "password" ? "text" : "password";
    },
    closeLogin() {
      let storageNik = localStorage.getItem("ACTIVE_NIK");

      if (storageNik) return this.$emit("showHideLogin", false);
      this.resetForm();
      this.$emit("showHideLogin", false);
    },
    submit() {
      // let storageNik = localStorage.getItem("ACTIVE_NIK");
      // if (storageNik || this.currentUser) {
      //   this.$dialog.notify.error(this.$t("error.multi-login-forbidden"), {
      //     position: "top-left",
      //     timeout: 5000,
      //   });
      //   return this.$router.push("/");
      // }

      if (this.processing) return;
      //Get public IP
      const { IpregistryClient } = require("@ipregistry/client");
      const client = new IpregistryClient("4g2za3n6kb93a9");
      //Public IP

      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        return this.setProcessing(false);
      }

      this.setProcessing(true);

      if (sendDeviceLocation === true) {
        //kalau config bilang kirim notif login, maka kirim
        client
          .lookup()
          .then((response) => {
            let res = response.data;
            let clientInfo = {
              ip: res.ip,
              isp: res.carrier.name + " (" + res.connection.organization + ")",
              location:
                res.location.city + " (" + res.location.region.name + ")",
              user_agent: res.user_agent.name,
              device:
                res.user_agent.os.type +
                ", OS : " +
                res.user_agent.os.name +
                " versi : " +
                res.user_agent.os.version,
            };
            return this.normalLogin(clientInfo);
          })
          .catch((error) => {
            console.error(error);
            //error but continue login without notif
            return this.normalLogin(undefined);
            // this.myIp = undefined;
          }).finally(() => {
            this.setProcessing(false);
          })

      } else {
        return this.normalLogin(undefined);
      }
    },
    normalLogin(clientInfo) {
      this.login({
        username: this.form.username,
        password: this.form.password,
        client_info: clientInfo,
      }).then((response) => {
        if (response && response.message === "eula_required") {
          // centang, progres scroll & timer di-reset oleh watcher eulaShow
          this.eulaClientInfo = clientInfo;
          this.eulaShow = true;
          return;
        }
        if (!this.loginAsPerson && this.currentUser) {
          this.$emit("subscribePushNotification");
          this.$router.push({ path: this.redirect || "/" });
        }
      });
    },
    measurePrivacyScroll() {
      const el = this.$refs.privacyContent;
      // elemen belum tampil (tinggi 0) jangan dianggap sudah sampai akhir
      if (!el || !el.clientHeight) return;

      const atEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_END_TOLERANCE;
      const pct = atEnd
        ? 100
        : Math.floor(((el.scrollTop + el.clientHeight) / el.scrollHeight) * 100);
      // simpan posisi terjauh, scroll ke atas tidak mengurangi progres
      this.privacyScrollPct = Math.max(this.privacyScrollPct, pct);
    },
    stopPrivacyTimer() {
      if (this.privacyTimer) clearInterval(this.privacyTimer);
      this.privacyTimer = undefined;
    },
    resetPrivacyProgress() {
      this.stopPrivacyTimer();
      this.eulaChecked = false;
      this.privacyScrollPct = 0;
      this.privacySecondsLeft = MIN_READ_SECONDS;
    },
    agreeEula() {
      if (!this.privacyHasRead || !this.eulaChecked || this.processing) return;
      this.login({
        username: this.form.username,
        password: this.form.password,
        client_info: this.eulaClientInfo,
        eula_accepted: true,
      }).then((response) => {
        if (response && response.message === "eula_required") return;
        this.closeEula();
        if (!this.loginAsPerson && this.currentUser) {
          this.$emit("subscribePushNotification");
          this.$router.push({ path: this.redirect || "/" });
        }
      }).catch(() => {
        this.closeEula();
      });
    },
    // Esc, X, atau "Tidak Setuju" = menolak; login dibatalkan
    disagreeEula() {
      if (this.processing) return;
      this.closeEula();
      this.setProcessing(false);
      this.$dialog.notify.error(
        "Anda harus menyetujui Pemberitahuan Privasi untuk dapat login.",
        { position: "top-left", timeout: 5000 }
      );
    },
    closeEula() {
      this.eulaShow = false;
      this.privacyShow = false;
      this.eulaClientInfo = undefined;
      this.resetPrivacyProgress();
    },
    loginAs(key) {
      this.login({
        username: this.form.username,
        password: this.form.password,
        key: key,
      }).then(() => {
        if (!this.currentUser) return this.resetForm();
        this.$emit("subscribePushNotification");
        this.$router.push({ path: this.redirect || "/" });
        this.setLoginAsPerson(undefined);
      });
    },
    resetForm() {
      this.setProcessing(false);
      this.$v.form.$reset();
      this.username = undefined;
      this.password = undefined;
    },
  },
};
</script>
<style>
.card__select-person {
  cursor: pointer !important;
}

.login__as-button {
  position: absolute !important;
  color: #ffffff38 !important;
  right: 0.5rem;
  bottom: 0.5rem;
  height: 70px;
  width: 70px;
}

.login__as-button .v-icon__svg {
  height: 70px !important;
  width: 70px !important;
}

.eula-card__icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eula-card__title {
  font-size: 1.35rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
}

.eula-card__desc {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
}

.eula-card__check .v-label.theme--light {
  font-size: 0.9rem;
  font-weight: 600;
  color: #0b7fc7;
  line-height: 1.5;
}

.eula-card__check {
  align-items: flex-start;
}

.eula-card__footer {
  font-size: 0.85rem;
}

.eula-card__check--locked,
.eula-card__check--locked * {
  cursor: not-allowed !important;
}

.eula-card__check--locked {
  opacity: 0.5;
}

.eula-card__hint {
  font-size: 0.8rem;
  color: #c2410c;
}

.v-dialog--scrollable>.privacy-card {
  /* kontainer isi (overflow-y-auto) mengikuti batas tinggi ini */
  max-height: 85vh;
}

.privacy-card__title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
}

.privacy-card__status {
  font-size: 1rem;
  color: #555;
  line-height: 1.7;
}

.privacy-card__body:focus {
  outline: 2px solid rgba(11, 127, 199, 0.4);
  outline-offset: -2px;
}

.change-pass-link {
  font-size: 1rem;
  color: #c81c9a;
  font-weight: 600;
  display: block;
  cursor: pointer;
}

.change-pass-link:hover {
  text-decoration: underline;
  color: #af1787;
}
</style>